import React, { useState, useEffect, useRef } from "react";
import Footer from "../components/Shared/Footer";
import EffectsOnHealth from "../components/Shared/EffectOnHealth";

const RiskofHeart = () => {

  const [isBlack, setIsBlack] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      // Toggle the color
      setIsBlack((prev) => !prev);
    }, 500); // Toggle every 0.5 seconds

    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, []);
  return (
    <div>
      {/* Breadcrumb Section */}
      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-contain">
                <h2>Risk of heart disease (Metabolic syndrome) </h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">
                        <i className="fa-solid fa-house"></i>
                      </a>
                    </li>
                    <li className="breadcrumb-item active">
                      Resources
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Defining Prediabetes Section */}
      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-5 d-flex align-items-center mb-3">

              <div className="custom-image-container fresh-image-2">
                <img
                  src="../assets/images/Riskofheartdieases/riskofheartdieases_2.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>


            </div>
            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3">
                        Defining Metabolic Syndrome
                      </h1>
                    </div>
                    <div className="font-md">
                      <p className="justify_content">
                        Metabolic syndrome refers to a group of conditions that together raise your risk of diabetes, stroke, and other serious health problems. Metabolic syndrome is also called insulin resistance syndrome.
                        You may have metabolic syndrome if you have three or more of the following conditions:
                      </p>
                      <ul className="custom-list mb-2  text-muted ">


                        <div className=" custom-list-item-height-two font-xsm">
                          <span className="me-2 bullet_point_black">  </span>  A large waistline of more than 80 cm for women and more than 94 cm for men: This is also called abdominal obesity or "having an apple shape". Extra fat in your stomach area is a bigger risk factor for heart disease than extra fat in other parts of your body.
                        </div>


                        <div className=" custom-list-item-height-two font-xsm">
                          <span className="me-2 bullet_point_black">  </span>  High blood pressure of 130/80 mm Hg or higher.
                        </div>

                        <div className=" custom-list-item-height-two font-xsm">
                          <span className="me-2 bullet_point_black">  </span>  High blood sugar/ Uncontrolled fasting blood sugar level ≥ 100 mg/dL (this may be a prediabetic condition)
                        </div>

                        <div className=" custom-list-item-height-two font-xsm">
                          <span className="me-2 bullet_point_black">  </span>
                          <span className="fw-semibold"> </span> High blood triglycerides of more than 150 mg/dL: Triglycerides are a type of fat found in your blood.

                        </div>

                        <div className=" custom-list-item-height-two font-xsm">
                          <span className="me-2 bullet_point_black">  </span>

                          <span className="fw-semibold"> </span>  Low HDL (good cholesterol) of less than 40 mg/dL for men and less than 50 mg/dL for women

                        </div>






                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section background_blue_section">
        <div className=" px-5">
          <div>
            <div className="review-title ">
              <h1 className="font-lg mb-3 text-center">
                Who is at risk for metabolic syndrome?
              </h1>
            </div>
            <div className="text-center mb-3">
              <div className="text-white font-xsm" >There are several risk factors:</div>
            </div>
          </div>
          <div className="row  d-flex justify-content-center algin-items-end">
            <div className="col-xl-4 mb-3 d-flex justify-content-end mobile-view-styling-metbolic align-items-center">
              <div>
                <div className="custom-lists margin-minus-risk-doct">
                  <div className="custom-list-item-height-two font-xsm">
                    <span className="me-2 bullet_point_white_who_risk"></span>
                    <span className="fw-semibold">Age</span>
                  </div>

                  <div className="custom-list-item-height-two font-xsm">
                    <span className="me-2 bullet_point_white_who_risk"></span>
                    <span className="fw-semibold">      Body mass index (BMI) greater than 25</span>
                  </div>

                  <div className="custom-list-item-height-two font-xsm">
                    <span className="me-2 bullet_point_white_who_risk"></span>
                    <span className="fw-semibold">Personal or family history of diabetes </span>
                  </div>

                  <div className="custom-list-item-height-two font-xsm">
                    <span className="me-2 bullet_point_white_who_risk"></span>
                    <span className="fw-semibold">Smoking</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-4 margin-four d-flex align-items-end justify-content-center">
              <div className="custom-image-container fresh-image">
                <img
                  src="../assets/images/Riskofheartdieases/peoplerisksection.png"
                  alt=""
                  className=" card_imd_fit"
                  style={{ objectFit: "contain", width: "100%", height: "auto" }}
                />
              </div>
            </div>
            <div className="col-xl-4 mb-3 mobile-view-styling-metbolic d-flex justify-content-start align-items-center">
              <div>
                <div className="custom-lists margin-minus-risk-doct-left ">




                  <div className="custom-list-item-height-two font-xsm">
                    <span className="me-2 bullet_point_white_who_risk"></span>
                    <span className="fw-semibold">Stress</span>
                  </div>

                  <div className="custom-list-item-height-two font-xsm">
                    <span className="me-2 bullet_point_white_who_risk"></span>
                    <span className="fw-semibold">Being post menopause</span>
                  </div>

                  <div className="custom-list-item-height-two font-xsm">
                    <span className="me-2 bullet_point_white_who_risk"></span>
                    <span className="fw-semibold">Sedentary lifestyle</span>
                  </div>

                  <div className="custom-list-item-height-two font-xsm">
                    <span className="me-2 bullet_point_white_who_risk"></span>
                    <span className="fw-semibold">History of heavy drinking</span>
                  </div>



                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div>
            <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
              <div className="col-xl-7 mb-3">
                <div className="fresh-contain p-center-left">
                  <div>
                    <div className="delivery-list">
                      <div className="review-title">
                        <h1 className="font-lg mb-3 ">
                          What are the symptoms of metabolic syndrome?
                        </h1>
                      </div>
                      <div className="font-md">
                        <p className="">
                          Certain conditions like, having high blood pressure,
                          high triglycerides, and being overweight or obese may
                          be signs of metabolic syndrome. In general, people do
                          not have symptoms. People with insulin resistance
                          often show acanthosis nigricans. This is darkened skin
                          areas on the back of the neck, in the armpits, and
                          under the breasts. The symptoms of metabolic syndrome
                          may look like other health conditions. See your
                          healthcare provider for a diagnosis.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-5 d-flex align-items-center ">
              <div className="custom-image-container fresh-image">
                <img
                  src="../assets/images/Riskofheartdieases/riskofheartdieases_2.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg  d-flex justify-content-center align-items-center">
          <div className="">
       


            <div className="row  d-flex justify-content-center align-items-center ">

              <div className="col-xl-6  ">
               
              <div className="review-title">
              <h1 className="font-lg mb-3 ">
                How is metabolic syndrome diagnosed?
              </h1>
            </div>
            <div className="">
              <p className="mb-4">
                Expert organizations have developed criteria to diagnose
                metabolic syndrome. Criteria include:
              </p>
            </div>
                <div className="d-flex  align-items-center ">
                  <div className="tickforrisk text-muted">
                  <div className="d-flex gap-2 font-sm align-items-center custom-ticks ">
                      <div className="font-lg fas fa-check "></div>
                      Abdominal obesity
                    </div>
                   
                    <div className="d-flex gap-2 font-sm align-items-center custom-ticks ">
                      <div className="font-lg fas fa-check "></div>
                      BMI above 25
                    </div>


                    <div className="d-flex gap-2 font-sm align-items-center   custom-ticks">
                      <div className="font-lg fas fa-check "></div>
                      High triglycerides and/or low HDL cholesterol
                    </div>
                    <div className="d-flex gap-2 font-sm align-items-center custom-ticks line_hieght_box_blue ">
                      <div className="font-lg fas fa-check margin-tick-risk-high-blood-section"></div>
                      High blood pressure or using medicine to lower blood pressure
                    </div>
                    <div className="d-flex gap-2 font-sm align-items-center  custom-ticks">
                      <div className="font-lg fas fa-check "></div>
                      High fasting blood glucose
                    </div>



                    <li className="d-flex gap-2 font-sm align-items-center custom-ticks">
                      <div className="font-lg fas fa-check "></div>
                      Insulin resistance
                    </li>



                  </div>
                </div>
              </div>
              <div className="col-xl-6 mb-2 ">
                <div className="custom-image-container fresh-image d-flex  align-items-center">
                  <img
                    src="../assets/images/Riskofheartdieases/riskofheartdieases_3.jpg"
                    alt=""
                    className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                  />
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg padding_5 d-flex justify-content-center align-items-center">
          <div className="card_type_section">
            <div className="review-title">
              <h1 className="font-lg mb-3 text-center">
                How is metabolic syndrome diagnosed?
              </h1>
            </div>
            <div className="text-center">
              <p className="">
                Expert organizations have developed criteria to diagnose
                metabolic syndrome. Criteria include:
              </p>
            </div>

 
            <div className="row  d-flex justify-content-center ">
              <div className="col-xl-6 mb-2 p-4">
              <div className="custom-image-container fresh-image d-flex  align-items-center">
                <img
                  src="../assets/images/Riskofheartdieases/riskofheartdieases_3.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
              </div>
              <div className="col-xl-6 d-flex  align-items-center  ">
                <div>
                  <ul className="tickforrisk text-muted">
                    <li className="d-flex gap-2 font-sm align-items-center custom-ticks font-xsm">
                      <div className="font-sm fas fa-check "></div>
                      Abdominal obesity
                    </li>
                    <li className="d-flex gap-2 font-sm align-items-center custom-ticks font-xsm">
                      <div className="font-lg fas fa-check "></div>
                      BMI above 25
                    </li>
                    
                 
                    <li className="d-flex gap-2 font-sm align-items-center font-xsm custom-list-item-height-risk custom-ticks">
                      <div className="font-lg fas fa-check "></div>
                      High blood pressure / lower blood pressure
                    </li>
                    <li className="d-flex gap-2 font-sm align-items-center custom-ticks custom-list-item-height-risk">
                      <div className="font-lg fas fa-check "></div>
                       Using medicine to lower blood pressure
                    </li>
                    <li className="d-flex gap-2 font-sm align-items-center font-xsm custom-ticks">
                      <div className="font-lg fas fa-check "></div>
                      High fasting blood glucose
                    </li>

                   

                    <li className="d-flex gap-2 font-sm align-items-center custom-ticks">
                      <div className="font-lg fas fa-check "></div>
                      Insulin resistance
                    </li>
             
                  </ul>
                </div>
              </div>
            </div>
            <div className="text-center">
              <div className="font-xsm color-blue-abdominal fw-semibold">
               This means you have prediabetes or type 2 diabetes
              </div>
            </div>
          </div>
        </div>
      </section> */}

<div className="background_banner_section_blue py-4">
        <div className="container-fluid-lg">
          <div className="d-flex align-items-center justify-content-center">
            <div className="ms-3 text-center text-white poppins-text   w-75">
              <div>
                <span className="text-center font-green-section-risk ">
                  Effects on Heart Health
                </span><br></br>
                <span className="font-sm">
                Metabolic syndrome can block the blood vessels with accumulation of fat, slow down or reduce blood flow and can lead to serious heart problems.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="fresh-vegetable-section section-lg-space  ">
        <div className="container-fluid-lg">
          <div className="review-title">
            <h1 className="font-lg mb-3">
              Type of Treatments
            </h1>
          </div>
          <div>
            <p className="font-xsm justify_content">
              
              Heart-healthy lifestyle changes are the first line of treatment for metabolic syndrome. You may have to see a dietitian and a physical therapist to help find a diet and exercise plan that works for you.
            </p>
          </div>
          <div>

            <EffectsOnHealth />
          </div>
        </div>
      </section>



      {/*  <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-5 d-flex align-items-center ">
              <div className="custom-image-container fresh-image">
                <img
                  src="../assets/images/Riskofheartdieases/riskofheartdieases_4.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>
            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3 ">Heart</h1>
                    </div>
                    <div className="font-md">
                      <p className="font-md">
                        Healthy lifestyle changes are the first line of
                        treatment for metabolic syndrome. You may have to see a
                        dietitian and a physical therapist to help find a diet
                        and exercise plan that works for you. If healthy
                        lifestyle changes do not work, you may need medicines or
                        weight loss surgery.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>  */}



      {/* <div className="background_banner_section_blue py-4">
        <div className="container-fluid-lg">
          <div className="d-flex align-items-center justify-content-center">
            <div className="ms-3 text-white fw-bold font-sm w-75">
              <div>
                <span className="text-center">
                Losing even a modest amount of weight can lower blood pressure
                and increase sensitivity to insulin.It can
               </span>
                <span className="text-center margin_y_no_important">
                also reduce the
                amount of fat around your middle. <br/>Diet, behavioural counselling,
                and exercise lower risk
                </span>
                <br></br>

                  <div  className="text-center">
                  factors more than diet by itself.
                  </div>
                 
              </div>
            </div>
          </div>
        </div>
      </div> */}






      {/*
      
  
    
    <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3 ">Diet</h1>
                    </div>
                    <div className="font-md">
                      <p className="">
                        Changes in diet are important in treating metabolic
                        syndrome. According to the AHA, treating insulin
                        resistance is the key to changing other risk factors. In
                        general, the best way to treat insulin resistance is by
                        losing weight and getting more physical activity.
                        Several studies have shown that losing weight by reduced
                        carbohydrate intake reduced the metabolic syndrome.
                      </p>
                      <p className="fw-bold font-sm mt-1">
                
                      Metabolic syndrome risk may be reduced with low-carb diet
               
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-5 d-flex align-items-center ">
              <div className="custom-image-container fresh-image">
                <img
                  src="../assets/images/Riskofheartdieases/riskofheartdieases_5.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/*<section className="fresh-vegetable-section section-lg-space background_blue_section ">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 ">
            <div className="col-xl-5 d-flex align-items-center mb-3 d-flex  align-items-center">
              <div className="custom-image-container fresh-image-2">
                <img
                  src="../assets/images/Riskofheartdieases/riskofheartdieases_6.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>

            <div className="col-xl-7  d-flex  align-items-center">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3 ">
                        Reduced Carbohydrate diet and Metabolic syndrome
                      </h1>
                    </div>
                    <div className="font-md">
                      <p className="text-white">
                        <span className="fw-semibold"> The latest new study published in <span className="font-italic"> Journal of Clinical
                        Investigation Insight (2024) </span>  suggests that low-carb diet
                        may have benefits for people at risk of developing type
                        2 diabetes even if they don’t lose any weight.</span>
                        It
                        included 16 men and women with metabolic syndrome, who
                        saw their metabolic syndrome reversed even though they
                        were fed diets that intentionally contained enough
                        calories to keep their weight stable. After eating the
                        low-carb diet, the participants had a variety of
                        significantly improved health measures, particularly
                        lower triglycerides and improved cholesterol readings.
                      </p>
                      <p className="text-white">
                        The researchers also reported evidence of increased
                        fat-burning efficiency after a low-carb diet and an
                        improvement in blood sugar. In another study exploring
                        the role of a lowering carbohydrates in patients with
                        metabolic syndrome found that a rapid reversal could be
                        achieved in just 4 weeks with lasting improvements in
                        postprandial insulin sensitivity, with these findings
                        independent of weight loss, which was locked out of the
                        equation in this study
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

     

      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg  d-flex justify-content-center align-items-center">
          <div className="card_type_section">
            <div className="row mb-3 d-flex justify-content-center">
            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3 ">Exercise</h1>
                    </div>
                    <div className="font-md">
                      <p className="">
                        Exercise helps people who are overweight or obese by
                        helping to keep and add lean body mass, or muscle
                        tissue, while losing fat. It also helps you lose weight
                        faster because muscle tissue burns calories faster.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-5 d-flex align-items-center p-4">
              <div className="custom-image-container fresh-image">
                <img
                  src="../assets/images/Riskofheartdieases/riskofheartdieases_7.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>
            </div>
            <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-5 d-flex align-items-center p-4">
              <div className="custom-image-container fresh-image-2">
                <img
                  src="../assets/images/Riskofheartdieases/riskofheartdieases_8.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>

            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3 ">Medicine</h1>
                    </div>
                    <div className="font-md">
                      <p className="">
                        People who have metabolic syndrome or are at risk for it
                        may need to take medicine as treatment. This is
                        especially true if diet and other lifestyle changes have
                        not made a difference. Your doctor may prescribe
                        medicine suitable for you.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          </div>
        </div>
      </section> */}




      <div>
        <Footer />
      </div>
    </div>
  );
};

export default RiskofHeart;
